export enum ConstrImportAction {
  UPDATE_IMPORT_DATA = '[constrimport] UPDATE_IMPORT_DATA',
  UPDATE_IMPORT_DATA_LAYERS = '[constrimport] UPDATE_IMPORT_DATA_LAYERS',
  UPDATE_CONNECT_VALIDATE_DATA = '[constrimport] UPDATE_CONNECT_VALIDATE_DATA',
  UPDATE_IMPORT_ACTION_DATA = '[constrimport] UPDATE_IMPORT_ACTION_DATA'
}
